<template>
  <div class="fts-lobby">
    <div class="fts-client-header">
      <div class="client-header-wrapper">
        <div class="client-header__l">
          <div class="client-header-label">
            <font-awesome-icon :icon="['fas', 'couch']" size="lg" class="client-header-label-icon" />
            <div class="client-header-label-title">
              Lobby
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="lobby-content">
      <div class="lobby-greeting">
        <div class="lobby-greeting-title">
          Welcome,
          <span>{{userProfileName}}</span>
        </div>
      </div>

      <div class="lobby-waiting-card">
        <div class="lobby-waiting-card-icon">
          <font-awesome-icon :icon="['far', 'hourglass']" />
        </div>

        <div class="lobby-waiting-card-message">
          You're in the lobby. Please wait while the workspace owner reviews your request to join and grants access.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authorizationStore } from '../store/authorizationStore';
import { clientStore } from '../store/clientStore';

export default {
  computed: {
    workspaceLobby() {
      return clientStore.getters.workspaceLobby;
    },
    userProfileName() {
      return authorizationStore.getters.userProfile.displayName;
    }
  },
  watch: {
    workspaceLobby(val) {
      if (!val) {
        this.$router.replace({ name: "dashboard" });
      }
    }
  },
  mounted() {
    if (!this.workspaceLobby) {
      this.$router.replace({ name: "dashboard" });
    }
  }
}
</script>

<style lang="scss" scoped>
.fts-lobby {
  .lobby-content {
    margin: 0 1rem 1rem;
  }
  .lobby-greeting {
    margin-bottom: 2rem;
  }
  .lobby-greeting-title {
    font-weight: 500;
    font-size: 1.125rem;
    line-height: 1.5;
    color: var(--fts-gray-700);
  }
  .lobby-waiting-card {
    max-width: 100%;
    width: 600px;
    margin-left: auto;
    margin-right: auto;
    padding: 1.5rem;
    border: 1px solid var(--fts-gray-100);
    border-radius: 0.375rem;
    box-shadow: var(--fts-elevation-1);
    text-align: center;
  }
  .lobby-waiting-card-icon {
    height: 4rem;
    width: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    margin-left: auto;
    margin-right: auto;
    border-radius: 10em;
    background-color: var(--fts-gray-200);
    font-size: 2rem;
  }
  .lobby-waiting-card-message {
    max-width: 24rem;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.875rem;
    line-height: 1.5;
    color: var(--fts-text);
  }
}
</style>

<style lang="scss">
/* --- Calm density, style-only round: the Lobby is two objects, a greeting and a card that
   says "wait", so it needs the shared chrome (Client.vue) plus a demotion and a panel.
   Namespaced like its siblings; nothing else renders .fts-lobby. */
.fts-client.fts-client--refined .fts-lobby {
  /* the same demotion the dashboard greeting takes: a quiet line, not a headline */
  .lobby-greeting {
    margin-bottom: 1rem;
    .lobby-greeting-title {
      font-weight: 500;
      font-size: 0.8125rem;
      line-height: 1.75rem;
      color: var(--cd-ink-2);
    }
  }
  /* the waiting card on the panel recipe: one hairline, radius 6, no shadow */
  .lobby-waiting-card {
    padding: 1.25rem;
    border-color: var(--cd-hairline);
    border-radius: 0.375rem;
    box-shadow: none;
    background-color: var(--fts-card-background);
  }
  .lobby-waiting-card-icon {
    height: 2.5rem;
    width: 2.5rem;
    margin-bottom: 1rem;
    background-color: var(--cd-rule);
    font-size: 1.125rem;
    color: var(--cd-ink-2);
  }
  /* the message is the only thing on the page worth reading - it keeps its ink */
  .lobby-waiting-card-message {
    font-size: 0.8125rem;
    line-height: 1.375rem;
  }
}
</style>
